import axios from "axios";

const CSRF_COOKIE_NAME = "simbarcsrftoken";
const CSRF_HEADER_NAME = "X-CSRFToken";

export default axios.create({
    xsrfCookieName: CSRF_COOKIE_NAME,
    xsrfHeaderName: CSRF_HEADER_NAME
});
